import { Icon } from "@iconify/react"
import { useQuery, keepPreviousData, useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Card, Flex, Grid, Input, message, Pagination, Table, Tag } from "antd"
import { userService } from "../../../services/user.service";
import TableAction from "../../../components/TableAction";
import { useEffect, useState } from "react";
import useTitleStore from "../../../store/titleStore";
import useDebounce from "../../../hooks/useDebounce";
import { useTableHeight } from "../../../hooks/useTableHeight";
import { useNavigate } from "react-router";

export default function UserIndex(){

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();

  const { setTitle } = useTitleStore();
  const queryClient = useQueryClient();

  const tableHeight = useTableHeight();

  const [messageApi, contextHolder] = message.useMessage();
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: [
      {
        operator: 'orWhere',
        value: [
          {
            field: 'name',
            operator: 'like',
            value: debouncedKeyword
          },
          {
            field: 'username',
            operator: 'like',
            value: debouncedKeyword
          }
        ]
      }
    ]
  })

  useEffect(() => {
    setTitle("Pengguna");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      filter: [
        {
          field: 'name',
          operator: 'like',
          value: debouncedKeyword
        }
      ]
    }));
  }, [debouncedKeyword]);

  const { data: usersData , isLoading, isRefetching } = useQuery({
    queryKey: ['users', dataParams],
    queryFn: () => userService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })

  const { mutate: handleDelete, isPending: deleteLoading } = useMutation({
    mutationFn: (id) => userService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('users');
      messageApi.success('Data berhasil dihapus');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const handleEdit = id => {
    navigate('/master-data/user/detail/'+id)
  }

  const users = usersData?.data;
  const pagination = usersData?.pagination || { total: 0, page: 1 };

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      fixed: breakpoint.md && 'left',
      render: (text, record, index) =>  index + 1,
    },
    {
      title: 'ID Pegawai',
      dataIndex: 'employeeId',
      width: 180,
      fixed: breakpoint.md && 'left',
    },
    {
      title: 'Username',
      dataIndex: 'username',
      width: 180
    },
    {
      title: 'Nama Lengkap',
      dataIndex: 'name',
      width: 180
    },
    {
      title: 'Hak Akses',
      dataIndex: 'permissions',
      width: 280,
      render: val => (
        <Flex wrap gap={6}  >
          {val.map((e,i) => <Tag key={i} style={{ marginRight: 4 }} color="cyan" >{e}</Tag>)}
        </Flex>
      )
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 120,
      fixed: 'right',
      render: record => (
        <TableAction
          onClickEdit={() => handleEdit(record.id)}
          handleDelete={() => handleDelete(record.id)}
          deleteLoading={deleteLoading}
          deleteDisabled={record.id == 1}
        />
      )
    },
  ]

  return (
    <>
      {contextHolder}
      <Card
        styles={{
          body: {
            paddingLeft: 0,
            paddingRight: 0
          }
        }}
      >
        <Flex gap={20} justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} >
          <Input 
            style={{ width: 320 }} 
            prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
            placeholder="cari berdasarkan nama atau username"
            onChange={e => setKeyword(e.target.value)}
            value={keyword}
          />
          <Button 
            variant="solid" 
            color="primary"  
            icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
            onClick={() => navigate('/master-data/user/create') }
            style={{ minWidth: 38 }}
          >
            {breakpoint.md && 'Tambah Pengguna'}
          </Button>
        </Flex>
        <Table
          columns={columns}
          size="small"
          loading={isLoading || isRefetching}
          rowKey={'id'}
          scroll={{ y: tableHeight }}
          dataSource={users}
          pagination={false}
        />
        <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={pagination.total}
          showSizeChanger={{
            showSearch: false,
          }}
          pageSizeOptions={['10', '20', '50']}
          current={pagination.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
      </Card>
    </>
  )
}